import { TabPanels, TabPanel, TabList, TabGroup, Tab } from '../Tabs';
import { useEffect, useState } from 'react';
import { fetchProfessional } from '../../providers/professionals';
import GeneralTab from '../professional-form/GeneralTab';
import ScheduleTab from '../professional-form/ScheduleTab';
import GapsTab from './GapsTab';
import { useTranslations } from '../../providers/i18n';

const tabs = ['Geral', 'Horário', 'Excepções'];

function ProfessionalForm({ id: professionalId, clinic_id, currentTab }) {
    const [t, translationsLoaded] = useTranslations('professional-form');
    const [professional, setProfessional] = useState({ clinic_id });

    useEffect(async () => {
        if (professionalId) {
            setProfessional(await fetchProfessional(professionalId));
        }
    }, []);

    if (professionalId && !professional.id) return null;
    if (!translationsLoaded) return null;

    return (
        <TabGroup className="flex flex-col h-full" tabKey="professionalFormTab" defaultIndex={currentTab}>
            <TabList className="mx-4">
                <Tab>{t('tabs.general')}</Tab>
                <Tab>{t('tabs.schedule')}</Tab>
                <Tab>{t('tabs.gaps')}</Tab>
            </TabList>
            <TabPanels className="flex-1 p-4 overflow-auto">
                <TabPanel>
                    <GeneralTab professional={professional} setProfessional={setProfessional} showClinic={!clinic_id} t={t} />
                </TabPanel>
                <TabPanel>
                    <ScheduleTab schedule={professional.schedule} t={t} />
                </TabPanel>
                <TabPanel>
                    <GapsTab gaps={professional.gaps} t={t} />
                </TabPanel>
            </TabPanels>
        </TabGroup>
    );
}

export default ProfessionalForm;
